import { render, staticRenderFns } from "./compRoleLogin.vue?vue&type=template&id=5134cf08&"
import script from "./compRoleLogin.vue?vue&type=script&lang=js&"
export * from "./compRoleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5134cf08')) {
      api.createRecord('5134cf08', component.options)
    } else {
      api.reload('5134cf08', component.options)
    }
    module.hot.accept("./compRoleLogin.vue?vue&type=template&id=5134cf08&", function () {
      api.rerender('5134cf08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compRoleLogin.vue"
export default component.exports